import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({ providedIn: 'root' })
export class SelectedPlanGuard implements CanActivate {
  constructor(private readonly subscriptionService: SubscriptionService, private readonly router: Router) {}

  canActivate(): boolean {
    const selectedPlan = this.subscriptionService.getSelectedPlan();
    if (!selectedPlan) {
      this.router.navigate(['/subscriptions']);
      return false;
    }

    return true;
  }
}
